module.exports = __webpack_public_path__ + "img/banner_v5.7584964a.png";